<script setup>
import {usePortalContentAndDesignStore} from "../../../../../../stores/partners/portalContentAndDesignStore";
import EditableTextField from "../../../../portal-editable-fields/EditableTextField.vue";
import EditableCustomField
    from "../../../../portal-editable-fields/custom-fields/EditableCustomField.vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const camelCase = (str) => {
    return str
        .replace(/[^a-zA-Z0-9 ]/g, '')
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
            index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, '');
};
</script>

<template>
    <div v-if="portalContentAndDesignStore.leadsPageSettings?.leads_form?.form_has_fields" class="space-y-5">
        <template v-for="field in portalContentAndDesignStore.leadsPageSettings?.leads_form?.fields">
            <div v-if="field.field_options?.program_leads_form" :key="field.id">
                <!-- Built-in fields (name, email) -->
                <template v-if="field.field_options.field === 'name'">
                    <editable-text-field
                        v-model="field.title"
                        :class="['block text-sm opacity-80 mb-1.5', portalContentAndDesignStore.getPageContentTextColorClass]"
                        for-attribute="name"
                        text-type="label"
                    />
                    <input
                        type="text"
                        name="name"
                        id="name"
                        required
                        v-model="portalContentAndDesignStore.leadsFormData.name"
                        :class="portalContentAndDesignStore.getInputStyle"
                    />
                </template>
                <template v-else-if="field.field_options.field === 'username'">
                    <editable-text-field
                        v-model="field.title"
                        :class="['block text-sm opacity-80 mb-1.5', portalContentAndDesignStore.getPageContentTextColorClass]"
                        for-attribute="username"
                        text-type="label"
                    />
                    <input
                        type="email"
                        name="username"
                        id="username"
                        required
                        v-model="portalContentAndDesignStore.leadsFormData.username"
                        :class="portalContentAndDesignStore.getInputStyle"
                    />
                </template>
            </div>

            <!-- Additional dynamic fields -->
            <div v-else>
                <editable-text-field
                    text-type="label"
                    v-model="field.title"
                    :for-attribute="`cfield_${field.id}`"
                    :class="['block text-sm mb-2 opacity-80', portalContentAndDesignStore.getPageContentTextColorClass]"
                />
                <editable-custom-field
                    :data="field"
                    v-model="portalContentAndDesignStore.leadsFormData"
                />
            </div>
        </template>
    </div>
</template>
